import { get } from '@bigyouth/base'
import scrollManager from '../utils/scrollManager'
import { srHide, srShow } from '../utils/srVisibility'

export default {
  name: 'info-product-sizing',

  ui: {
    triggerModal: '[js-info-product-sizing-trigger-modal]',
    modal: '[js-info-product-sizing-modal]',
    closeModal: '[js-info-product-sizing-close-modal]',
  },

  events: [
    {
      target: 'triggerModal',
      on: 'click',
      handle () {
        srShow(this.ui.modal)
        setTimeout(function () {
          scrollManager.stop()
        }, 500)
      },
    },
    {
      target: 'modal',
      on: 'click',
      handle (e) {
        if (e.target.closest('.modal__inner') === null) {
          srHide(this.ui.modal)
          scrollManager.restart()
        }
      },
    },
    {
      target: 'closeModal',
      on: 'click',
      handle () {
        srHide(this.ui.modal)
        scrollManager.restart()
      },
    },
  ],

  componentDidMount () {
    // Move modal to modals layer
    const modalsLayer = get('.modals')
    modalsLayer.appendChild(this.ui.modal)
  },
}
